
// STYLES
import styles from '../css/product.module.css';

// ICONS
import { IoIosAdd } from 'react-icons/io';
import { FiMinus } from "react-icons/fi";

// UTILS
import { formatValue } from "../../../scripts/formatValue";


const RenderComplements = ({ collection, index, companyData, complementsCount, changeComplementsAmount }) => {

    return collection.complements.length > 0 && (

        <li key={index}>
            <div className={styles.collectionArea}>
                <div className={styles.topCollection}>
                    <div className={styles.collectionComponents}>
                        <div className={styles.titleArea}>
                            <p className={styles.titleCollection}>{collection.name}</p>

                            {/* SHOW / HIDDEN MAX ITEMS TO SELECT */}
                            {collection.max != null && collection.max > 0 ? (
                                <p className={styles.maxOptionsCollection}>
                                    Selecione até {collection.max} {parseInt(collection.max) == 1 ? 'item' : 'itens'}
                                </p>
                            ) : null}
                        </div>

                        {/* SHOW / HIDDEN MANDATORY ALERT */}
                        {collection.mandatory ? (
                            <p className={styles.mandatoryAlert} style={{ backgroundColor: companyData.background_color, color: companyData.text_color }}>
                                Obrigatório
                            </p>
                        ) : null}
                    </div>
                </div>

                <div className={styles.complementsArea}>

                    {/* RENDERIZA OS COMPLEMENTOS DA COLEÇÃO ATUAL */}

                    {collection.complements.map((comp, compIndex) => {
                        const compPrice = comp.price ? `+ ${formatValue(comp.price)}` : 'Gratuito';

                        const selectOne = collection.max == 1;

                        const reachedMax = comp.count == 1 &&  selectOne ? true : false;

                        if(comp.view){
                            return (
                                <li key={compIndex}>
                                    <div className={styles.complementComponent}>
                                        <div className={styles.complementContainer}>
                                            <div className={styles.complementsInformationsArea}>
                                                <p className={styles.textComplement} id={styles.complementName}>
                                                    {comp.name}
                                                </p>
    
                                                {comp.description && (
                                                    <p className={styles.textComplement} id={styles.complementDescription}>
                                                        {comp.description}
                                                    </p>
                                                )}
    
                                                <p className={styles.textComplement} id={styles.complementPrice} style={{ color: companyData.background_color }}>
                                                    {compPrice}
                                                </p>
                                            </div>
    
                                            {comp.image && (
                                                <img src={comp.image} style={{width: 60, height: 50, borderRadius: 5, marginRight: 15}}/>
                                            )}

                                            {companyData.type != 'view' ?
                                                <div className={[styles.complementsButtonArea, {zIndex: 10}]}>
                                                    {selectOne ? (
                                                        <input
                                                            type="checkbox"
                                                            className={styles.checkboxComplementButton}
                                                            // Não desabilita mais os demais itens quando a coleção já está no máximo (max=1):
                                                            // changeComplementsAmount agora troca a seleção automaticamente ao marcar um
                                                            // item diferente, então o checkbox precisa continuar clicável nesse caso.
                                                            checked={complementsCount.some((item) => item.id === comp.id)}
                                                            style={{ '--background-color': companyData.background_color, accentColor: companyData.background_color }}
                                                            onChange={() => {
                                                                // FILTRA SE ESSE COMPLEMENTO JÁ FOI ADICIONADO
                                                                const validation = complementsCount.filter((item) => item.id == comp.id);
    
                                                                changeComplementsAmount(validation.length == 0 ? 'add' : 'minus', collection.id, comp.id, true);
                                                            }}
                                                        />
    
                                                    ) : (
    
                                                        <div style={{ padding: 5, display: 'flex', flexDirection: 'row', backgroundColor: comp.image && comp.count > 0 ? '#fff' : 'transparent', borderRadius: 5 }}>
                                                            {((comp.image && comp.count > 0) || !comp.image) && (
                                                                <>
                                                                    <button 
                                                                        className={styles.complementQuantity} 
                                                                        style={{ backgroundColor: companyData.background_color }} 
                                                                        id="subtract-complement" 
                                                                        onClick={() => changeComplementsAmount('minus', collection.id, comp.id)}
                                                                    >
                                                                        <FiMinus size={20} color={companyData.text_color} />
                                                                    </button>
    
                                                                    <p 
                                                                        className={styles.complementQuantity} 
                                                                        style={{ color: companyData.background_color }} 
                                                                        id="number-qtd"
                                                                    >
                                                                        {comp.count}
                                                                    </p>
                                                                </>
                                                            )}
    
                                                            <button 
                                                                className={styles.complementQuantity} 
                                                                id="add-complement" 
                                                                style={{ backgroundColor: reachedMax ? '#999' : companyData.background_color }} 
                                                                onClick={() => changeComplementsAmount('add', collection.id, comp.id)}
                                                            >
                                                                <IoIosAdd size={20} color={companyData.text_color} />
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>                                            
                                            : null}
                                        </div>
                                    </div>
                                </li>
                                
                            );
                        }
                    })}
                </div>
            </div>
        </li>
    )

};


export default RenderComplements;